import { useId } from "react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";

// Shared Age + Gender input block used on every calculator.
// Pass `hideGender` for calculators that are intrinsically single-sex (pregnancy suite).
export default function AgeGenderFields({ age, setAge, gender, setGender, hideGender = false }) {
  const uid = useId();
  return (
    <div className={`grid gap-4 ${hideGender ? "sm:grid-cols-1" : "sm:grid-cols-2"}`}>
      <div className="space-y-2">
        <Label htmlFor={`${uid}-age`}>Age</Label>
        <Input
          id={`${uid}-age`}
          type="number"
          inputMode="numeric"
          data-testid="in-age"
          placeholder="years"
          value={age}
          onChange={(e) => setAge(e.target.value)}
        />
      </div>
      {!hideGender && (
        <div className="space-y-2">
          <Label>Gender</Label>
          <RadioGroup value={gender} onValueChange={setGender} className="flex gap-2" data-testid="gender-toggle">
            {["male", "female"].map((g) => (
              <div key={g} className="flex-1">
                <RadioGroupItem value={g} id={`${uid}-${g}`} className="peer sr-only" />
                <Label
                  htmlFor={`${uid}-${g}`}
                  className="flex h-10 cursor-pointer items-center justify-center rounded-full border border-border text-sm font-medium capitalize peer-data-[state=checked]:bg-primary peer-data-[state=checked]:text-primary-foreground peer-data-[state=checked]:border-primary"
                >
                  {g}
                </Label>
              </div>
            ))}
          </RadioGroup>
        </div>
      )}
    </div>
  );
}
